import React from 'react'

export const VideoRecordingIllustration = () => {
    return (
        <svg
            width="35"
            height="60"
            viewBox="0 0 69 119"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.14346 34.0464V20.6651C8.14346 19.5786 7.27203 18.6978 6.19709 18.6978C5.12214 18.6978 4.25 19.5786 4.25 20.6651V34.0464C4.25 35.1337 5.12142 36.0145 6.19709 36.0145C7.27275 36.0145 8.14346 35.1337 8.14346 34.0464Z"
                fill="currentColor"
            />
            <path
                d="M10.6016 17.5174V38.2453C10.6016 39.3318 11.473 40.2127 12.5486 40.2127C13.6243 40.2127 14.495 39.3318 14.495 38.2453V17.5174C14.495 16.4309 13.6236 15.5493 12.5486 15.5493C11.4737 15.5493 10.6016 16.4309 10.6016 17.5174Z"
                fill="currentColor"
            />
            <path
                d="M16.9453 8.07163V46.6407C16.9453 47.7273 17.8167 48.6088 18.8917 48.6088C19.9666 48.6088 20.8388 47.728 20.8388 46.6407V8.07163C20.8388 6.98507 19.9673 6.10352 18.8917 6.10352C17.816 6.10352 16.9453 6.98507 16.9453 8.07163Z"
                fill="currentColor"
            />
            <path
                d="M23.2891 18.5667V36.1458C23.2891 37.2323 24.1605 38.1139 25.2362 38.1139C26.3118 38.1139 27.1825 37.233 27.1825 36.1458V18.5667C27.1825 17.4802 26.3111 16.5986 25.2362 16.5986C24.1612 16.5986 23.2891 17.4795 23.2891 18.5667Z"
                fill="currentColor"
            />
            <path
                d="M29.6328 2.82407V51.8878C29.6328 52.9744 30.5042 53.856 31.5799 53.856C32.6556 53.856 33.527 52.9751 33.527 51.8878V2.82407C33.527 1.73679 32.6556 0.855957 31.5799 0.855957C30.5042 0.855957 29.6328 1.73679 29.6328 2.82407Z"
                fill="currentColor"
            />
            <path
                d="M35.9766 13.3192V41.3929C35.9766 42.4794 36.848 43.361 37.9229 43.361C38.9979 43.361 39.87 42.4802 39.87 41.3929V13.3192C39.87 12.2326 38.9986 11.3511 37.9229 11.3511C36.8473 11.3511 35.9766 12.2319 35.9766 13.3192Z"
                fill="currentColor"
            />
            <path
                d="M42.3203 17.5174V38.2453C42.3203 39.3318 43.1917 40.2127 44.2674 40.2127C45.3431 40.2127 46.2138 39.3318 46.2138 38.2453V17.5174C46.2138 16.4309 45.3423 15.5493 44.2674 15.5493C43.1925 15.5493 42.3203 16.4309 42.3203 17.5174Z"
                fill="currentColor"
            />
            <path
                d="M48.6719 8.07163V47.6896C48.6719 48.7769 49.5433 49.6577 50.6182 49.6577C51.6932 49.6577 52.5653 48.7769 52.5653 47.6896V8.07163C52.5653 6.98507 51.6939 6.10352 50.6182 6.10352C49.5426 6.10352 48.6719 6.98507 48.6719 8.07163Z"
                fill="currentColor"
            />
            <path
                d="M55.0156 18.5667V37.1954C55.0156 38.2819 55.887 39.1635 56.9627 39.1635C58.0384 39.1635 58.9091 38.2827 58.9091 37.1954V18.5667C58.9091 17.4802 58.0377 16.5986 56.9627 16.5986C55.8878 16.5986 55.0156 17.4795 55.0156 18.5667Z"
                fill="currentColor"
            />
            <path
                d="M65.2528 32.9973V21.7152C65.2528 20.6286 64.3814 19.7471 63.3057 19.7471C62.2301 19.7471 61.3594 20.6279 61.3594 21.7152V32.9973C61.3594 34.0838 62.2308 34.9654 63.3057 34.9654C64.3807 34.9654 65.2528 34.0845 65.2528 32.9973Z"
                fill="currentColor"
            />
            <path
                d="M13.8864 69.856C6.64899 69.856 0.75 75.7007 0.75 82.8716V105.84C0.75 113.011 6.64899 118.856 13.8864 118.856H55.6136C62.851 118.856 68.75 113.011 68.75 105.84V82.8716C68.75 75.7007 62.851 69.856 55.6136 69.856H13.8864ZM13.8864 74.4497H55.6136C60.3627 74.4497 64.1136 78.1662 64.1136 82.8716V105.84C64.1136 110.546 60.3627 114.262 55.6136 114.262H13.8864C9.13734 114.262 5.38636 110.546 5.38636 105.84V82.8716C5.38636 78.1662 9.13734 74.4497 13.8864 74.4497ZM29.3409 84.4028V104.309L46.3409 94.356L29.3409 84.4028Z"
                fill="currentColor"
            />
        </svg>
    )
}
